import { Box, Button, Typography } from '@mui/material';
import { Fragment } from 'react';
import {
  chromeExtensionLink,
  downloadPlugin,
  newCommonChromeExtensionModalTexts
} from 'src/common/config/TextMessage';
import { newCommonChromeExtensionModalSx } from 'src/content/individualScans/individualSxs';
import { UpgradePlanLiteModalSxs } from 'src/content/keywordResearch/keywordResearchCSS';
import { pluginInstallTrackEvent } from './Analytics';
import { openNewTab } from './config/FunctionHelper';

export const NewCommonChromeExtensionModal = () => {
  let chromeExtension = false;

  /**
   * Check whether the Chrome extension exists.
   */
  if (document.querySelector('#rough-water-seo-root') == null) {
    chromeExtension = true;
  } else {
    chromeExtension = false;
  }
  return (
    <Fragment>
      {chromeExtension && (
        <Box sx={newCommonChromeExtensionModalSx?.mainBox}>
          <Box>
            <Box sx={UpgradePlanLiteModalSxs?.headerBox}>
              <img
                style={UpgradePlanLiteModalSxs?.img}
                src={
                  process.env.PUBLIC_URL + `/static/images/icons/info_green.svg`
                }
                alt="icon"
              />
              <Box>
                <Typography sx={newCommonChromeExtensionModalSx?.headerText}>
                  {newCommonChromeExtensionModalTexts?.installPlugin}
                </Typography>
                <Typography sx={newCommonChromeExtensionModalSx?.desc}>
                  {newCommonChromeExtensionModalTexts?.desc}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'stretch', sm: 'space-between' },
              alignItems: 'center',
              width: { xs: '100%', sm: 'auto' }
            }}
          >
            <Box sx={{ flex: 1, display: { xs: 'none', sm: 'block' } }} /> {/* Spacer – hidden on mobile */}
            <Button
              variant="contained"
              className="download-chrome-plugin"
              sx={{
                width: { xs: '100%', sm: 'auto' },
                height: 10,
                fontFamily: 'PoppinsThin',
                py: 2.5,
                borderRadius: 0.6,
                marginRight: { xs: 0, sm: '5px' },
                backgroundColor: 'var(--color-secondary)',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                '&:hover': {
                  backgroundColor: 'var(--color-secondary)'
                }
              }}
              onClick={() => {
                // Function to open a new tab with the Chrome extension download link
                pluginInstallTrackEvent();
                openNewTab(chromeExtensionLink);
              }}
            >
              <Typography sx={{ color: 'var(--color-primary)', fontWeight: 400 }}>
                {downloadPlugin}
              </Typography>
            </Button>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};
